import React, { Component } from 'react'
import { Table, Tag, Button, Drawer, Form, Input, Select, InputNumber, DatePicker, Popconfirm, message, Collapse } from 'antd';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import SimpleReactValidator from "simple-react-validator";
import { createNewSharedOperator, getsharedOperatorDetails, UpdateSharedOperator, dataUpdateGeneralDetails } from "../../api/index";
import moment from 'moment';
import AssetDelete from "../site_components/asset_delete";
import { checkServiceType } from "../../actions/service-type";



class sharedOutOperators extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        this.state = {
            showModal: false,
            open: false,
            openEdit: false,
            title: "",
            tabaleLoading: false,
            actionView: false,
            selectedAssetId: null,
            AssetType: [],
            selectedMakeId: null,
            makeType: [],

            soohandletenant: '',
            sharedPowerType: '',
            sooDcPowerCapacity: '',
            sooBillingMethod: '',
            sooGenPowerNoofPhases: '',
            sooCommercialPowerNoofPhases: '',
            sooCommercialPowerPerPhaseCapacity: '',
            sooGenPowerPerPhaseCapacity: '',
            sooBillingAmount: '',
            sooBillingStartDate: null,
            selectedModelId: null,
            modelType: [],
            fbclastMaintainanceDate: null,
            fbcwarrantyExpireDate: null,
            fbcInstalledDate: null,
            openViewMoreDetails: false,
            selectedElement: "",
            AssetManagementPermission: false,
            switchStatus: true,
            objectSet: {
                "noOfPIVCopies": 0,
                "sooCEBLECODepot": null,
                "powerConnectionAuthority": null,
                "powerConnectedDate": null,
                "sooCapexAmount3PPowerConnection": 0,
            },

            dropdownObjSoo : {
                "powerConnectionAuthority": "",
                "soohandletenant": "",
                "sharedPowerType": "",
                "sooCommercialPowerNoofPhases": "",
                "sooCommercialPowerPerPhaseCapacity": "",
                "sooGenPowerPerPhaseCapacity": "",
                "sooGenPowerNoofPhases": "",
                "sooDcPowerCapacity": "",
                "sooBillingMethod": "",
            }

        };
        this.requestFromClose = this.requestFromClose.bind(this);

        this.handletenant = this.handletenant.bind(this);
        this.handleSharedPowerType = this.handleSharedPowerType.bind(this);

        this.handleDCPowerCapacity = this.handleDCPowerCapacity.bind(this);
        this.handleCommercialPowerNoofPhases = this.handleCommercialPowerNoofPhases.bind(this);
        this.handleBillingMethod = this.handleBillingMethod.bind(this);
        this.handleCommercialPowerPerPhaseCapacity = this.handleCommercialPowerPerPhaseCapacity.bind(this);
        this.handleGenPowerNoofPhases = this.handleGenPowerNoofPhases.bind(this);
        this.handleGenPowerPerPhaseCapacity = this.handleGenPowerPerPhaseCapacity.bind(this);
        this.handleBillingAmount = this.handleBillingAmount.bind(this);


    }
    handleBillingAmount(e) {
        console.log(e)
        this.setState({ sooBillingAmount: e });
    }
    handleGenPowerPerPhaseCapacity(e) {
        this.setState({ sooGenPowerPerPhaseCapacity: e });
    }
    handleGenPowerNoofPhases(e) {
        this.setState({ sooGenPowerNoofPhases: e });
    }
    handleCommercialPowerPerPhaseCapacity(e) {
        console.log(e)
        this.setState({ sooCommercialPowerPerPhaseCapacity: e });
    }
    handleCommercialPowerNoofPhases(e) {
        // console.log(e)
        this.setState({ sooCommercialPowerNoofPhases: e });
    }
    handleBillingMethod(e) {
        this.setState({ sooBillingMethod: e });
    }

    handleSharedPowerType(e) {
        this.setState({ sharedPowerType: e });
    }
    handletenant(e) {
        this.setState({ soohandletenant: e });
    }
    sharedOutOperatorsUpdata(id) {
        // console.log('dfdfd')
        console.log(id)
        this.getDataSharedOutOperatorsDetails(id);
        this.setState({ openEdit: true });
    }
    getDataSharedOutOperatorsDetails = async (id) => {
        var res = await getsharedOperatorDetails(id);
        console.log(res);
        if (res.success) {
            this.setState({
                sharedOperatorEdit: res.data,
                sharedOperatorId: res.data.id,
                soohandletenant: res.data?.tenant,
                sharedPowerType: res.data?.sharedPowerType,
                sooDcPowerCapacity: res.data?.dcPowerCapacity,
                sooBillingMethod: res.data?.billingMethod,
                sooCommercialPowerNoofPhases: res.data?.commercialPowerNoofPhases,
                sooCommercialPowerPerPhaseCapacity: res.data?.commercialPowerPerPhaseCapacity,
                sooGenPowerNoofPhases: res.data?.genPowerNoofPhases,
                sooGenPowerPerPhaseCapacity: res.data?.genPowerPerPhaseCapacity,
                sooBillingAmount: res.data?.billingAmount,



            })
            if (res.data?.billingStartDate != null) {

                this.setState({
                    sooBillingStartDate: res.data?.billingStartDate
                })
            } else {

                this.setState({
                    sooBillingStartDate: '',
                })
            }



        }
    }
    handleDCPowerCapacity(e) {
        console.log(e)
        this.setState({ sooDcPowerCapacity: e });
    }

    requestFromClose() {
        console.log('dsdsd')
        this.setState({ showModal: true, open: true });
    }

    componentDidMount() {
        if (JSON.parse(localStorage.getItem('serviceTypeSet')) == null) {
            const { history } = this.props;

            history.push("/");

        } else {

            this.getSetPageData(JSON.parse(localStorage.getItem('serviceTypeSet')),38)

        }
        checkServiceType(38).then((data) => this.setState({
            AssetManagementPermission: data
        }, () => {
        }),

        )

        this.setState({
            objectSet: {
                // "noOfPIVCopies": this.props.details?.access_technologies_data?.noOfPIVCopies,
                // "sooCEBLECODepot": this.props?.details?.access_technologies_data?.sooCEBLECODepot,
                // "powerConnectionAuthority": this.props?.details?.access_technologies_data?.powerConnectionAuthority,
                // "powerConnectedDate": this.props.details?.access_technologies_data?.powerConnectedDate,
                "sooCapexAmount3PPowerConnection": this.props.details?.access_technologies_data?.sooCapexAmount3PPowerConnection,
            }
        })
        // console.log(this.props.details2)
    }
    getSetPageData = (serviceTypeIs, Pageid) => {

        if (serviceTypeIs.serviceType.filter(checkuser => checkuser?.id == Pageid)[0] != null) {
            console.log('fddf');
            this.setState({
                actionView: true,
            })
        }

    };
    onDrawerClose = () => {
        console.log('sddsds')
        this.formRef.current.resetFields();
        this.setState({
            open: false,
            openEdit: false,
            selectedAssetId: null,
            AssetType: [],
            selectedMakeId: null,
            makeType: [],
            fbcCapacity: '',
            selectedModelId: null,
            modelType: [],
            fbcCapacity: '',
            fbclastMaintainanceDate: null,
            fbcwarrantyExpireDate: null,
            fbcInstalledDate: null,
            soohandletenant: '',
            sharedPowerType: '',
            sooDcPowerCapacity: '',
            sooBillingMethod: '',
            sooGenPowerNoofPhases: '',
            sooCommercialPowerNoofPhases: '',
            sooCommercialPowerPerPhaseCapacity: '',
            sooGenPowerPerPhaseCapacity: '',
            sooBillingAmount: '',
            sooBillingStartDate: null,

        })

    }
    onChangeAsset = (value) => {
        console.log("onChangeAsset");
        //console.log(value);
        this.setState({
            selectedAssetId: value,
            AssetType: {
                "id": value
            },

        })
    };
    onChangeMake = (value) => {
        console.log("onChangeMake");
        //console.log(value);
        this.setState({
            selectedMakeId: value,
            makeType: {
                "id": value
            },

        })
    };
    onChangeModel = (value) => {
        console.log("onChangeModel");
        //console.log(value);
        this.setState({
            selectedModelId: value,
            modelType: {
                "id": value
            },

        })
    };
    onChangeInstalledDate = (date, dateString) => {
        console.log(date);
        console.log(dateString);
        this.setState({
            fbcInstalledDate: dateString,
        });
    };
    onChangeBillingStartDate = (date, dateString) => {
        console.log(date);
        console.log(dateString);
        this.setState({
            sooBillingStartDate: dateString,
        });
    };
    onChangeLastMaintainanceDate = (date, dateString) => {
        console.log(date);
        console.log(dateString);
        this.setState({
            fbclastMaintainanceDate: dateString,
        });
    };
    
    AllDataSubmitUpdate = async () => {
        var dataSet;

        dataSet = {
            "id": this.state.sharedOperatorId,
            "site": { "id": this.props?.detailsSite?.site_details.id },
            "asset": {
                "id": 3
            },
            "tenant": this.state.soohandletenant,
            "sharedPowerType": this.state.sharedPowerType,
            "dcPowerCapacity": this.state.sooDcPowerCapacity,
            "billingMethod": this.state.sooBillingMethod,
            "commercialPowerNoofPhases": this.state.sooCommercialPowerNoofPhases,
            "commercialPowerPerPhaseCapacity": this.state.sooCommercialPowerPerPhaseCapacity,
            "genPowerNoofPhases": this.state.sooGenPowerNoofPhases,
            "genPowerPerPhaseCapacity": this.state.sooGenPowerPerPhaseCapacity,
            "billingStartDate": this.state.sooBillingStartDate,
            "billingAmount": this.state.sooBillingAmount
        }
        console.log(dataSet)
        var res = await UpdateSharedOperator(dataSet);
        console.log(res)
        if (res.success) {
            message.success('Successfully Shared-Out Operators Edited!');
            this.formRef.current.resetFields();

            this.setState({
                showModal: false,
                open: false,
                openEdit: false,

                selectedAssetId: null,
                AssetType: [],
                selectedMakeId: null,
                makeType: [],
                fbcCapacity: '',
                selectedModelId: null,
                modelType: [],
                fbcCapacity: '',
                fbclastMaintainanceDate: null,
                fbcwarrantyExpireDate: null,
                fbcInstalledDate: null,
                soohandletenant: '',
                sharedPowerType: '',
                sooDcPowerCapacity: '',
                sooBillingMethod: '',
                sooGenPowerNoofPhases: '',
                sooCommercialPowerNoofPhases: '',
                sooCommercialPowerPerPhaseCapacity: '',
                sooGenPowerPerPhaseCapacity: '',
                sooBillingAmount: '',
                sooBillingStartDate: null,
            })
            this.props.parentMethod();

        } else {
            message.warning(' Something went wrong!')
        }
    }
    AllDataSubmit = async () => {
        var dataSet;

        dataSet = {

            "site": { "id": this.props?.detailsSite?.site_details.id },
            "asset": {
                "id": 3
            },
            "tenant": this.state.soohandletenant,
            "sharedPowerType": this.state.sharedPowerType,
            "dcPowerCapacity": this.state.sooDcPowerCapacity,
            "billingMethod": this.state.sooBillingMethod,
            "commercialPowerNoofPhases": this.state.sooCommercialPowerNoofPhases,
            "commercialPowerPerPhaseCapacity": this.state.sooCommercialPowerPerPhaseCapacity,
            "genPowerNoofPhases": this.state.sooGenPowerNoofPhases,
            "genPowerPerPhaseCapacity": this.state.sooGenPowerPerPhaseCapacity,
            "billingStartDate": this.state.sooBillingStartDate,
            "billingAmount": this.state.sooBillingAmount
        }
        console.log(dataSet)
        var res = await createNewSharedOperator(dataSet);
        if (res.success) {
            message.success('Successfully Shared-Out Operators Added!');
            this.formRef.current.resetFields();

            this.setState({
                showModal: false,
                open: false,

                selectedAssetId: null,
                AssetType: [],
                selectedMakeId: null,
                makeType: [],
                fbcCapacity: '',
                selectedModelId: null,
                modelType: [],
                fbcCapacity: '',
                fbclastMaintainanceDate: null,
                fbcwarrantyExpireDate: null,
                fbcInstalledDate: null,
                soohandletenant: '',
                sharedPowerType: '',
                sooDcPowerCapacity: '',
                sooBillingMethod: '',
                sooGenPowerNoofPhases: '',
                sooCommercialPowerNoofPhases: '',
                sooCommercialPowerPerPhaseCapacity: '',
                sooGenPowerPerPhaseCapacity: '',
                sooBillingAmount: '',
                sooBillingStartDate: null,
            })
            this.props.parentMethod();
            // const { history } = this.props;
            // history.push("/site");
        } else {
            message.warning(' Something went wrong!')
        }

    }
    submitForm = async (id) => {
        var res = await getsharedOperatorDetails(id);
        console.log(res);
        if (res.success) {
            var respons = AssetDelete.Action(res.data, this.props?.detailsSite?.site_details.id, UpdateSharedOperator)
            respons.then((value) => {
                if (value == 1) {
                    message.success('Successfully Delete!')
                    this.props.parentMethod();
                } else {
                    message.warning(' Something went wrong!')
                }
            });
        }
    }

    viewMoreDetails(element) {
        this.setState({
            showModal2: true,
            openViewMoreDetails: true,
            selectedElement: element
        });
    }

    onViewMoreDetailsDrawerClose = () => {
        this.setState({
            showModal2: false,
            openViewMoreDetails: false,
        })
    }

    validatedTextLable = (field) => {
        return (field !== null && field !== '')
            ? <span class="badge badge-outline-secondary text-muted">{(field)}</span>
            : <span class="badge text-danger">Currently Not Set</span>;
    }

    
    onChangepowerConnectedDate = (date, dateString) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                powerConnectedDate: dateString
            }

        }, () => {
            console.log(this.state.objectSet)
        })
    };
    handlsooCEBLECODepot = (e) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                sooCEBLECODepot: e.target.value
            }

        }, () => {
            console.log(this.state.objectSet)
        })

    }
    handlpowerConnectionAuthority = (e) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                powerConnectionAuthority: e.target.value
            }

        }, () => {
            console.log(this.state.objectSet)
        })
    }
    handlnoOfPIVCopies = (e) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                noOfPIVCopies: e
            }
        }, () => {
            console.log(this.state.objectSet)
        })
    }
    
    handlsooCapexAmount3PPowerConnection = (e) => {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                sooCapexAmount3PPowerConnection: e
            }

        }, () => {
            console.log(this.state.objectSet)
        })
    }

    
    dataUpdate() {
        console.log("ssss")
        this.setState({
            switchStatus: false
        })
    }
    close = async () => {
        this.props.parentMethod();
        this.setState({
            objectSet: {
                "noOfPIVCopies": this.props.details?.access_technologies_data?.noOfPIVCopies,
                "sooCEBLECODepot": this.props?.details?.access_technologies_data?.sooCEBLECODepot,
                "powerConnectionAuthority": this.props?.details?.access_technologies_data?.powerConnectionAuthority,
                "powerConnectedDate": this.props.details?.access_technologies_data?.powerConnectedDate,
                "sooCapexAmount3PPowerConnection": this.props.details?.access_technologies_data?.sooCapexAmount3PPowerConnection,
            }
        })
        this.setState({
            switchStatus: true
        });
    }
    dataSetToUpdate = async () => {

        console.log(this.state.objectSet)
        console.log(this.props.detailsupdateGeneralDetails.updateGeneralDetails)
        let remoteJob = {
            ...this.props.detailsupdateGeneralDetails.updateGeneralDetails,
            ...this.state.objectSet
        };
        const formData = new FormData();
        formData.append('id', this.props?.details?.access_technologies_data?.id);
        formData.append('object', JSON.stringify(remoteJob));

        var res = await dataUpdateGeneralDetails(formData);

        if (res.success) {
            message.success('Successfully Update!')
            this.props.parentMethod();
            this.setState({
                switchStatus: true
            })
        } else {
            message.warning(' Something went wrong!')
        }
    }

    render() {
        const { Option } = Select;
        const { Panel } = Collapse;
        const _shearedPower = this.state.selectedElement
        const columns2 = [
            {
                title: "Tenant",
                content: this.validatedTextLable(_shearedPower.tenant),
                details: [],
            },
            {
                title: "Shared power type",
                content: _shearedPower !== ""
                    ? <Tag color="gray" style={{ margin: "0px" }}><span>{_shearedPower.sharedPowerType}</span></Tag> : <></>,
                details: [],
            },
            {
                title: "Commercial - Power No of Phases",
                content: this.validatedTextLable(_shearedPower.commercialPowerNoofPhases),
                details: [],
            },
            {
                title: "Commercial Power - Per Phase Capacity (A)",
                content: this.validatedTextLable(_shearedPower.commercialPowerPerPhaseCapacity),
                details: [],
            },
            {
                title: "Gen Power - No of Phases",
                content: this.validatedTextLable(_shearedPower.genPowerNoofPhases),
                details: [],
            },
            {
                title: "Gen Power- Per Phase Capacity (A)",
                content: this.validatedTextLable(_shearedPower.genPowerPerPhaseCapacity),
                details: [],
            },
            {
                title: "DC Power Capacity (A)",
                content: this.validatedTextLable(_shearedPower.dcPowerCapacity),
                details: [],
            },
            {
                title: "Billing Method",
                content: this.validatedTextLable(_shearedPower.billingMethod),
                details: [],
            },
            {
                title: "Billing Start Date",
                content: this.validatedTextLable(_shearedPower.billingStartDate),
                details: [],
            },
            {
                title: "Billing Amount (LKR)",
                content: this.validatedTextLable(_shearedPower.billingAmount),
                details: [],
            },
        ];
        return (
            <>
                <div className='row'>
                    <div className='row'>
                        <div class="col-lg-12">
                            <div class="text-end">
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        {this.state.actionView
                                            ? <button type="button" class="btn btn-soft-primary btn-sm" onClick={this.requestFromClose}><i class="fas fa-plus me-2"></i>Add Shared-Out Operators</button>
                                            : ('')
                                        }
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div class="card">
                                <div class="card-header">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h4 class="card-title">Information</h4>
                                        {this.state.switchStatus
                                            ? <button type="button" class="btn btn-soft-primary btn-icon-square-sm" onClick={() => this.dataUpdate()}> <i class="mdi mdi-pencil-outline"></i></button>
                                            : <div class="d-flex justify-content-end align-items-center">
                                                <button type="button" class="btn btn-soft-secondary " onClick={() => this.close()} style={{ marginRight: "10px" }}> Cancel </button>
                                                <button type="button" class="btn btn-soft-primary " onClick={() => this.dataSetToUpdate()}> Submit to Update </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div className='col-md-6'>
                                            <ul class="list-group">

                                                {/* <li class="list-group-item d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <i class="la la-hand-o-right text-primary me-2"></i> No of PIV Copies
                                                    </div>
                                                    {this.state.switchStatus ? (<>{this.props.details?.access_technologies_data?.noOfPIVCopies != null ? (<span class="badge badge-outline-success">{this.props.details?.access_technologies_data?.noOfPIVCopies}</span>) : (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<>  <InputNumber min={0} style={{ width: '20%' }} value={this.state.objectSet?.noOfPIVCopies} id="airCoolingMethod" onChange={this.handlnoOfPIVCopies} /> </>)}
                                                </li> */}
                                                {/* <li class="list-group-item d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <i class="la la-hand-o-right text-primary me-2"></i>  Power Connection Authority
                                                    </div>
                                                    <div>
                                                        {this.state.switchStatus.toString() == "true" ? (
                                                            this.props?.details?.access_technologies_data?.powerConnectionAuthority ?(
                                                                <span class="badge badge-outline-success">{this.props?.details?.access_technologies_data?.powerConnectionAuthority}</span>
                                                            ) : (
                                                                <span class="badge badge-outline-danger">Currently Not Set</span>
                                                            )
                                                        ) : (
                                                            <Select
                                                                defaultValue={this.props?.details?.access_technologies_data?.powerConnectionAuthority}
                                                                style={{ width: 120 }}
                                                                onChange={(e) => {
                                                                    this.state.objectSet.powerConnectionAuthority = e;
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["powerConnectionAuthority"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        )}
                                                    </div>
                                                </li> */}
                                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <i class="la la-hand-o-right text-primary me-2"></i> Total Capex Amount (LKR)
                                                    </div>
                                                    {this.state.switchStatus ? (<>{this.props.details?.access_technologies_data?.sooCapexAmount3PPowerConnection != null ? (<span class="badge badge-outline-success">{this.props.details?.access_technologies_data?.sooCapexAmount3PPowerConnection}</span>) : (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<>  <InputNumber min={0} style={{ width: '20%' }} value={this.state.objectSet?.sooCapexAmount3PPowerConnection} id="airCoolingMethod" onChange={this.handlsooCapexAmount3PPowerConnection} /> </>)}
                                                </li>
                                            </ul>
                                        </div>

                                        {/* <div className='col-md-6'>
                                            <ul class="list-group">
                                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <i class="la la-hand-o-right text-primary me-2"></i>  CEB/LECO Depot
                                                    </div>
                                                    {this.state.switchStatus ? (<>{this.props?.details.access_technologies_data?.sooCEBLECODepot != null ? 
                                                    (<span class="badge badge-outline-success">{this.props?.details.access_technologies_data?.sooCEBLECODepot}</span>) : 
                                                    (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<>  <Input style={{ width: '20%' }} 
                                                    value={this.state.objectSet?.sooCEBLECODepot} id="airCoolingMethod" onChange={this.handlsooCEBLECODepot} /> </>)}
                                                </li>
                                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <i class="la la-hand-o-right text-primary me-2"></i>  Power Connected Date
                                                    </div>
                                                    {this.state.switchStatus ? (<> {this.props?.details.access_technologies_data?.powerConnectedDate != null ? 
                                                    (<span class="badge badge-outline-success">{this.props?.details.access_technologies_data?.powerConnectedDate}</span>) : 
                                                    (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<>  <DatePicker style={{ width: "100%" }} 
                                                    defaultValue={this.state.objectSet?.powerConnectedDate != null ? (moment(this.state.objectSet?.powerConnectedDate)) : ("")} 
                                                    onChange={this.onChangepowerConnectedDate} /> </>)}
                                                </li>
                                            </ul>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.props.details2.sharedOutOperatorses_data.map((element) => (
                        <div className='col-md-4'>
                            <div class="card">
                                <div class="card-header">
                                    <div class="d-flex justify-content-start align-items-center">
                                        <img src={'https://static.vecteezy.com/system/resources/previews/001/902/502/large_2x/telecommunication-radio-antenna-and-satelite-tower-with-blue-sky-free-photo.JPG'} alt="" class="thumb-md rounded" />
                                        <div class="badge badge-soft-primary" style={{ padding: "5px", marginLeft: "15px", border: "1px solid rgba(0, 0, 0, 0.05)" }}>
                                            <i class="la la-home font-14 text-dark" style={{ paddingLeft: "10px" }} />
                                            <i class="la la-angle-right text-dark font-14" style={{ padding: "5px" }} />
                                            <span class="fw-semibold text-pink">{this.props?.detailsSite?.site_details.siteName}</span>
                                            <i class="la la-angle-right text-dark font-14" style={{ padding: "5px" }} />
                                            <span class="fw-semibold text-primary" style={{ paddingRight: "10px" }}>{element.tenant}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="col">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="fw-normal m-0">Tenant</h6>
                                            <span class="text-muted fw-normal">{element.tenant}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="fw-normal m-0">Shared power type</h6>
                                            <span class="badge bg-secondary">{element.sharedPowerType}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="fw-normal m-0">DC Power Capacity (A)</h6>
                                            <span class="badge badge-outline-info badge-pill">{element.dcPowerCapacity}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="fw-normal m-0">Gen Power- Per Phase Capacity (A)</h6>
                                            <div class="d-flex align-items-center">
                                                <span class="badge badge-soft-success fw-semibold">{element.genPowerPerPhaseCapacity}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="card-footer m-0">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <a href="#custom-modal" class="btn btn-soft-dark btn-sm waves-effect btn-round" onClick={() => this.viewMoreDetails(element)}>
                                            <i class="mdi mdi mdi-unfold-more-horizontal"></i> More Details </a>
                                        <div class="text-end">
                                            {this.state.AssetManagementPermission
                                                ? (<button type="button" class="btn btn-soft-primary btn-icon-square-sm" onClick={() => this.sharedOutOperatorsUpdata(element.id)} style={{ marginRight: "8px" }}><i class="mdi mdi-pencil-outline"></i></button>)
                                                : ("")}
                                            <Popconfirm
                                                title="Are You Sure?"
                                                description="Are you sure to delete this task?"
                                                onConfirm={() => this.submitForm(element.id)}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                {this.state.AssetManagementPermission
                                                    ? (<button type="button" class="btn btn-soft-danger btn-icon-square-sm"><i class="mdi mdi-trash-can-outline"></i></button>)
                                                    : ('')}
                                            </Popconfirm>
                                        </div>
                                    </div>
                                </p>
                            </div>
                        </div>
                    ))}

                    <Drawer maskClosable={false} title={"Shared-Out Operators Details"} width={"50%"} placement="right" onClose={() => this.onViewMoreDetailsDrawerClose()} visible={this.state.openViewMoreDetails} closeIcon={<button type="button" class="btn btn-soft-danger btn-icon-square-sm" style={{ marginRight: "8px" }}><i class="mdi dripicons-cross"></i></button>}>
                        <Collapse style={{ borderColor: "lavender", alignContent: "center" }}>
                            {columns2.map((item) => (
                                <Panel
                                    style={{ borderColor: "lavender" }}
                                    header={
                                        <li class="d-flex justify-content-between align-items-center">
                                            <div>
                                                {item.details.length == 0 ? <i class="la la-hand-o-right text-primary" style={{ paddingLeft: "5px", paddingRight: "5px" }} /> : <></>}
                                                <span class="fw-normal m-2">{item.title}</span>
                                            </div>
                                            {item.content}
                                        </li>
                                    }
                                    key={item.title}
                                    showArrow={item.details.length > 0}
                                    collapsible={item.details.length > 0 ? "" : "icon"}
                                >
                                    {item.details.map((detail) => (
                                        <li class="d-flex justify-content-between align-items-center me-2" style={{ paddingBottom: "10px", paddingLeft: "10px" }}>
                                            <div>
                                                <i class="la la-circle text-primary me-2"></i> <span>{detail.title}</span>
                                            </div>
                                            {detail.content}
                                        </li>
                                    ))}
                                </Panel>
                            ))}
                        </Collapse>
                    </Drawer>

                    <Drawer maskClosable={false} title={"New Shared-Out Operators"} width={"60%"} placement="right" onClose={() => this.onDrawerClose()} visible={this.state.open} closeIcon={<button type="button" class="btn btn-soft-danger btn-icon-square-sm" style={{ marginRight: "8px" }}><i class="mdi dripicons-cross"></i></button>}>
                        <div className="row" >
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <Form
                                            ref={this.formRef}
                                        >
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcdu">
                                                        Tenant <x style={{ color: "#ff0000" }}>*</x>
                                                    </label>
                                                    <Form.Item required name="tenant" tooltip="This is a required field">
                                                        <div>
                                                            <Select
                                                                id='tenant'
                                                                showSearch
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handletenant(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["soohandletenant"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c" }}>{this.state.soohandletenant == null || this.state.soohandletenant == "" ? "This is a required field" : ""}</p>
                                                    </Form.Item> 
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="SharedPowerType">
                                                        Shared Power Type <x style={{ color: "#ff0000" }}>*</x>
                                                    </label>
                                                    <Form.Item required name="SharedPowerType" tooltip="This is a required field">
                                                        {/* <Input id="SharedPowerType" onChange={this.handleSharedPowerType} /> */}
                                                        <div>
                                                            <Select
                                                                id='SharedPowerType'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleSharedPowerType(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sharedPowerType"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c" }}>{this.state.sharedPowerType == null || this.state.sharedPowerType == "" ? "This is a required field" : ""}</p>
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                        Commercial Power No of Phases
                                                    </label>
                                                    <Form.Item required name="commercialPowerNoofPhases" >
                                                        {/* <Input id="commercialPowerNoofPhases" onChange={this.handleCommercialPowerNoofPhases} /> */}
                                                        <div>
                                                            <Select
                                                                id='commercialPowerNoofPhases'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleCommercialPowerNoofPhases(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooCommercialPowerNoofPhases"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                    Commercial Power - Per Phase Capacity (A)
                                                    </label>
                                                    <Form.Item required name="commercialPowerPerPhaseCapacity" >
                                                        <div>
                                                            <Select
                                                                id='commercialPowerPerPhaseCapacity'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleCommercialPowerPerPhaseCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooCommercialPowerPerPhaseCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                        Gen Power No of Phases
                                                    </label>
                                                    <Form.Item required name="genPowerNoofPhases" >
                                                        <div>
                                                            <Select
                                                                id='genPowerNoofPhases'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleGenPowerNoofPhases(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooGenPowerNoofPhases"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="genPowerPerPhaseCapacity">
                                                        Gen Power- Per Phase Capacity (A)
                                                    </label>
                                                    <Form.Item required name="genPowerPerPhaseCapacity" >
                                                        <div>
                                                            <Select
                                                                id='genPowerPerPhaseCapacity'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleGenPowerPerPhaseCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooGenPowerPerPhaseCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                        DC Power Capacity (A)
                                                    </label>
                                                    <Form.Item required name="dcPowerCapacity" >
                                                        {/* <InputNumber style={{ width: '100%' }} id="dcPowerCapacity" onChange={this.handleDCPowerCapacity} /> */}
                                                        <div>
                                                            <Select
                                                                id='dcPowerCapacity'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleDCPowerCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooDcPowerCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcdu">
                                                        Billing Method
                                                    </label>
                                                    <Form.Item required name="billingMethod" tooltip="This is a required field">
                                                        {/* <Input id="billingMethod" onChange={this.handleBillingMethod} /> */}
                                                        <div>
                                                            <Select
                                                                id='billingMethod'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleBillingMethod(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooBillingMethod"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        Billing Start Date
                                                    </label>
                                                    <Form.Item required name="billingStartDate" tooltip="This is a required field">
                                                        <DatePicker

                                                            style={{ width: "100%" }}
                                                            onChange={this.onChangeBillingStartDate}
                                                        />
                                                        {/* <p style={{ color: "#f5325c" }}>{this.validator2.message('depot', this.state.siteOnAirDate, 'required')}</p> */}
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="billingAmount">
                                                    Billing Amount (LKR)
                                                    </label>
                                                    <Form.Item required name="billingAmount" >
                                                        <InputNumber style={{ width: '100%' }} id="billingAmount" onChange={this.handleBillingAmount} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Form>
                                        <div className='row' style={{ justifyContent: "end" }}>
                                            <div className='col-md-2' >   
                                            {this.state.soohandletenant == null || this.state.soohandletenant == "" || this.state.sharedPowerType == null || this.state.sharedPowerType == "" ?
                                            (<button className="btn btn-primary" disabled>
                                                Add This Asset
                                            </button>) : 
                                            (<button className="btn btn-primary" onClick={() => this.AllDataSubmit()}>
                                                Add This Asset
                                            </button>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Drawer>

                    <Drawer maskClosable={false} title={"Edit Shared-Out Operators"} width={"70%"} placement="right" onClose={() => this.onDrawerClose()} visible={this.state.openEdit} closeIcon={<button type="button" class="btn btn-soft-danger btn-icon-square-sm" style={{ marginRight: "8px" }}><i class="mdi dripicons-cross"></i></button>}>
                        <div className="row" >
                            <div className="col-lg-12">
                                <div className="card">

                                    <div className="card-body">
                                        <Form
                                            ref={this.formRef}
                                        >
                                            <div className='row'>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcdu">
                                                        Tenant <x style={{ color: "#ff0000" }}>*</x>
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                id='tenant'
                                                                showSearch
                                                                value={this.state.soohandletenant}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handletenant(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["soohandletenant"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c" }}>{this.state.soohandletenant == null || this.state.soohandletenant == "" ? "This is a required field" : ""}</p> 
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="SharedPowerType">
                                                        Shared Power Type <x style={{ color: "#ff0000" }}>*</x>
                                                    </label>
                                                    <Form.Item>
                                                        <div>
                                                            <Select
                                                                id='SharedPowerType'
                                                                value={this.state.sharedPowerType}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleSharedPowerType(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sharedPowerType"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                        <p style={{ color: "#f5325c" }}>{this.state.sharedPowerType == null || this.state.sharedPowerType == "" ? "This is a required field" : ""}</p>
                                                    </Form.Item>
                                                </div>
                                                
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                        Commercial Power No of Phases
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                id='commercialPowerNoofPhases'
                                                                style={{ width: '100%' }}
                                                                value={this.state.sooCommercialPowerNoofPhases}
                                                                onChange={(e) => {
                                                                    this.handleCommercialPowerNoofPhases(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooCommercialPowerNoofPhases"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                    Commercial Power - Per Phase Capacity (A)
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                id='commercialPowerPerPhaseCapacity'
                                                                value={this.state.sooCommercialPowerPerPhaseCapacity}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleCommercialPowerPerPhaseCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooCommercialPowerPerPhaseCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                            
                                           
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcPowerCapacity">
                                                        Gen Power No of Phases
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                id='genPowerNoofPhases'
                                                                value={this.state.sooGenPowerNoofPhases}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleGenPowerNoofPhases(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooGenPowerNoofPhases"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="genPowerPerPhaseCapacity">
                                                    Gen Power- Per Phase Capacity (A)
                                                    </label>
                                                    <Form.Item  >
                                                        <div>
                                                            <Select
                                                                value={this.state.sooGenPowerPerPhaseCapacity}
                                                                id='genPowerPerPhaseCapacity'
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleGenPowerPerPhaseCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooGenPowerPerPhaseCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                    
                                        
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcdu">
                                                    DC Power Capacity (A)
                                                    </label>
                                                    <Form.Item >
                                                        <div>
                                                            <Select
                                                                id='dcdu_Capacity'
                                                                value={this.state.sooDcPowerCapacity}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleDCPowerCapacity(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooDcPowerCapacity"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label" for="dcdu">
                                                        Billing Method
                                                    </label>
                                                    <Form.Item>
                                                        <div>
                                                            <Select
                                                                id='billingMethod'
                                                                value={this.state.sooBillingMethod}
                                                                style={{ width: '100%' }}
                                                                onChange={(e) => {
                                                                    this.handleBillingMethod(e);
                                                                }}>
                                                                {this.props.dropdownSoo["dropdownObjSoo"]["sooBillingMethod"]?.map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </Form.Item>
                                                </div>
                                    
                                                <div className="col-md-6">
                                                    <label className="form-label" for="depot">
                                                        Billing Start Date
                                                    </label>
                                                    {this.state.sooBillingStartDate != null ? (<Form.Item >
                                                        <DatePicker
                                                            defaultValue={this.state.sooBillingStartDate != '' ? (moment(this.state.sooBillingStartDate)) : ("")}
                                                            style={{ width: "100%" }}
                                                            onChange={this.onChangeBillingStartDate}
                                                        />
                                                        </Form.Item>) : ('')}
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="form-label" for="billingAmount">
                                                    Billing Amount (LKR)
                                                    </label>
                                                    <Form.Item  >
                                                        <InputNumber style={{ width: '100%' }} value={this.state.sooBillingAmount} id="billingAmount" onChange={this.handleBillingAmount} />
                                                    </Form.Item>
                                                </div>

                                                </div>
                                        
                                        </Form>

                                        <div className='row' style={{ justifyContent: "end" }}>
                                            <div className='col-md-2' >   
                                            {this.state.soohandletenant == null || this.state.soohandletenant == "" || this.state.sharedPowerType == null || this.state.sharedPowerType == "" ?
                                            (<button className="btn btn-primary" disabled>
                                                Update This Asset
                                            </button>) : 
                                            (<button className="btn btn-primary" onClick={() => this.AllDataSubmitUpdate()}>
                                                Update This Asset
                                            </button>)}
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </Drawer>
                </div>


            </>
        )
    }
}
export default sharedOutOperators;
